import React, { useEffect, useState, useRef } from "react";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { FixedSizeGrid } from "react-window";
import COS from "cos-js-sdk-v5";
import Button from "../../components/Button";
import NavBack from "../../components/NavBack/NavBack";
import { GameModal } from "../../components/GameModal/GameModal";
import { QRCodeModalComponent } from "../../components/QRCodeModal/QRCodeModal";
import { Confirm } from "../../components/confirm/confirm";
import store from "../../store/store";
import {
  apiRequest,
  showLoading,
  showAlert,
  rem2px,
  PLAYER_URL_PREFIX,
} from "../../utils";
import QRCodeModal from "../../components/QRCodeModal/QRCodeModal";

import ss from "./Backstage.module.css";

export default function Photos() {
  const navigate = useNavigate();
  const sessionUUID = new URLSearchParams(window.location.search).get(
    "session_uuid"
  );
  const [photoList, setPhotoList] = useState();
  // modal type: game_process, team_info, adjust_energy, failed_reason
  const gameModalType = useRef("");
  const [gameModalVisible, setGameModalVisible] = useState(false);
  const failedReasonType = useRef("");
  // 场次信息
  const [sessionInfo, setSessionInfo] = useState({});
  // cos 配置
  const cosConfig = useRef();

  const getCosConfig = async () => {
    apiRequest("/get_cos_config", "GET", { sid: sessionUUID })
      .then((res) => {
        if (res.code === 0) cosConfig.current = res.data;
        else console.error("failed to get upload token");
      })
      .catch((err) => {
        console.error("failed to request get upload token:", err);
        showAlert("网络异常，请刷新重试");
      });
  };

  const getPhotoList = () => {
    const loading = showLoading("加载中");
    apiRequest("/all_photo_list", "GET", {
      game_uuid: sessionUUID,
    })
      .then((res) => {
        if (res.code === 0) {
          setPhotoList(res.player_photos);
        } else {
          showAlert(res.msg);
        }
      })
      .finally(() => {
        loading.hide();
      });
  };

  const getSessionInfo = () => {
    // const loading = showLoading("加载中");
    apiRequest("/get_session_info", "GET", {
      session_uuid: sessionUUID,
    }).then((res) => {
      if (res.code === 0) {
        setSessionInfo(res.game_session);
      } else {
        showAlert(res.msg);
      }
    });
    // .finally(() => loading.hide());
  };

  useEffect(() => {
    getSessionInfo(sessionUUID);
    store.dispatch.gameSession.setSessionUUID(sessionUUID);
    getPhotoList();
    getCosConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionUUID]);

  if (!photoList) return;

  const GridCell = ({ columnIndex, rowIndex, style }) => {
    let photoIdx = rowIndex * 4 + columnIndex;
    // 场次结束增加游戏结束卡片
    if (sessionInfo.status > 100) {
      if (photoIdx === 0) {
        return <div className={ss.endCard}>照片列表</div>;
      } else {
        photoIdx -= 1;
      }
    }
    const photo = photoList[photoIdx];
    if (!photo) return;
    return (
      <div
        className={classNames(ss.photoCard, photo.status > 1 && ss.judged)}
        key={photo.id}
        style={style}
      >
        <div
          className={ss.flag}
          style={{
            backgroundImage: `url(${require(`../img/flag${photo.team_color}.png`)})`,
          }}
          num={photo.team_color} // 索引从0开始，但编号从1开始
          width={1.67}
          onClick={() => {
            // 请求标记照片
            apiRequest("/mark_player_photo", "POST", {
              photo_id: photo.id,
              marked: photo.marked ? 0 : 1,
            }).then((res) => {
              if (res.code === 0) {
                // 修改 photo 状态，重新 render 这个元素
                photo.marked = !photo.marked;
                setPhotoList([...photoList]);
              } else {
                showAlert(res.msg);
              }
            });
          }}
        >
          <div className={classNames(ss.checkMark, photo.marked && ss.show)} />
        </div>
        <div className={ss.photoBox} style={{ filter: "grayscale(0)" }}>
          <img src={photo.photo} alt="" />
        </div>
        <div className={ss.photoInfo}>
          <div
            className={ss.taskDesc}
            dangerouslySetInnerHTML={{ __html: photo.task_desc }}
          ></div>
          <div className={ss.btnBar}>
            {photo.status < 2 && (
              <>
                <div
                  className={ss.photoBtn}
                  onClick={() => {
                    gameModalType.current = "failed_reason";
                    failedReasonType.current = photo.id;
                    setGameModalVisible(true);
                  }}
                >
                  失败
                </div>
                <div
                  className={ss.photoBtn}
                  onClick={() => {
                    const loading = showLoading("加载中");
                    apiRequest("/check_player_photo", "POST", {
                      session_uuid: sessionUUID,
                      photo_id: photo.id,
                      success: 1,
                    })
                      .then((res) => {
                        if (res.code === 0) {
                          getPhotoList();
                        } else {
                          showAlert(res.msg);
                        }
                      })
                      .finally(() => {
                        loading.hide();
                      });
                  }}
                >
                  成功
                </div>
              </>
            )}
            {photo.status === 2 && <>判定成功</>}
            {photo.status === 3 && <>判定失败：{photo.failed_reason_desc}</>}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={ss.bg}>
      <div className={ss.top}>
        <NavBack onClick={() => navigate(-1)} />
        <Button
          title={"清空标记"}
          onClick={() => {
            if (photoList.every((photo) => !photo.marked)) {
              showAlert("没有标记的照片，无需取消");
              return;
            }
            Confirm.show("请确认是否取消所有标记", () => {
              const loading = showLoading("加载中");
              apiRequest("/unmark_all_player_photos", "POST", {
                session_uuid: sessionUUID,
              })
                .then((res) => {
                  if (res.code === 0) {
                    getPhotoList();
                  } else {
                    showAlert(res.msg);
                  }
                })
                .catch((err) => console.log(err))
                .finally(() => loading.hide());
            });
          }}
        />
        <Button
          title={"生成花絮"}
          onClick={() => {
            if (sessionInfo.status < 200) {
              showAlert("当前场次未结束，无法生成花絮");
              return;
            }
            Confirm.show("请确认是否生成花絮", () => {
              const markedList = photoList.filter((photo) => photo.marked);
              // 把 markedList 转换为字符串，上传到 cos，已 session_uuid 为文件名
              const loading = showLoading("生成花絮中");
              const cos = new COS(cosConfig.current);
              cos.putObject(
                {
                  Bucket: "wanpilaoban-1314240291",
                  Region: "ap-beijing",
                  Key: `outdoor/report/${sessionUUID}.json`,
                  Body: JSON.stringify(markedList),
                },
                (err, data) => {
                  loading.hide();
                  if (err) {
                    console.error("上传花絮失败", err);
                    showAlert("上传花絮失败，请稍后重试");
                  } else {
                    showAlert("生成花絮成功！");
                  }
                }
              );
            });
          }}
        />
        <Button
          title={"花絮二维码"}
          onClick={() => {
            // 展示花絮二维码
            QRCodeModal.show({
              type: "report",
              url: `${PLAYER_URL_PREFIX}/report?sid=${sessionUUID}`,
              onClose: () => {
                QRCodeModal.hide();
              },
            });
          }}
        />
      </div>

      <div className={ss.photoList}>
        <FixedSizeGrid
          columnCount={4} // 列数
          columnWidth={rem2px(466 + 36)} // 列宽
          height={rem2px(1356)} // 网格高度
          rowCount={Math.floor(photoList.length / 4) + 1} // 行数
          rowHeight={rem2px(844 + 50)} // 行高
          width={rem2px(2048)} // 网格宽度
          overscanColumnCount={4}
          overscanRowCount={1}
        >
          {GridCell}
        </FixedSizeGrid>
      </div>
      <GameModal
        visible={gameModalVisible}
        type={gameModalType.current}
        onClose={() => setGameModalVisible(false)}
        onConfirm={(value) => {
          if (gameModalType.current === "failed_reason") {
            const loading = showLoading("加载中");
            apiRequest("/check_player_photo", "POST", {
              session_uuid: sessionUUID,
              photo_id: failedReasonType.current,
              success: 0,
              failed_reason: value,
            })
              .then((res) => {
                if (res.code === 0) {
                  getPhotoList();
                } else {
                  showAlert(res.msg);
                }
              })
              .finally(() => {
                loading.hide();
              });
          }
        }}
      />
      <QRCodeModalComponent />
    </div>
  );
}
